module.exports = __webpack_public_path__ + "img/orgDetail_3.a6b2c98a.png";